import React, { useState, useEffect } from 'react'
import _ from 'lodash/fp'
import moment from 'moment'
import { graphql } from 'react-apollo'
import { Link } from 'react-router-dom'

import Typography from '@material-ui/core/Typography'

import { withStyles } from '@material-ui/core/styles'

import Avatar from '@material-ui/core/Avatar'
import Hidden from '@material-ui/core/Hidden'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'

import { getClubLogo } from '../config'
import { connect } from 'react-redux'
import Spinner from '@fe/ui/Spinner'
import NoSuchUser from '@fe/ui/errors/NoSuchUser'
import colors from '@fe/ui/colors'

import * as authReducer from '../reducers/auth'

import { loader } from 'graphql.macro'
const gamesListQuery = loader('./gamesList.gql')

const DiffFormat = ({ children }) => children > 0 ? '+' + children : children || 'Par'

const styles = {
}

const GameRowBase = ({
  userHandle,
  gameId,
  clubId,
  clubName,
  guideTitle,
  gamePlayedAt,
  gameTotalPar,
  gameHandicap,
  gameShots,
  gamePoints,
  toPar,
  toCh,
  gameHandle,
  classes
}) => {
  return (
    <TableRow
      hover
      component={Link}
      to={`/u/${userHandle}/games/${gameHandle}`}
    >
      <TableCell style={{ width: 40, paddingLeft: 12 }} padding='none' classes={classes}>
        <Avatar
          src={getClubLogo(clubId)}
          imgProps={{
            onError: e => {
              e.target.src = 'https://my.glfr.com/static/media/glfr-logo.png'
            }
          }}
        />
      </TableCell>
      <TableCell classes={classes}>{clubName}</TableCell>
      <TableCell classes={classes}>{guideTitle}</TableCell>
      <TableCell classes={classes}>{moment(gamePlayedAt * 1000).format('l')}</TableCell>
      <TableCell classes={classes}>
        <Typography variant='h5'>{gameTotalPar}</Typography>
      </TableCell>
      <TableCell classes={classes}>
        <Typography variant='h5'>{gameHandicap}</Typography>
      </TableCell>
      <TableCell classes={classes}>
        <Typography variant='h5'>{gameShots || '-'}</Typography>
      </TableCell>
      <TableCell classes={classes}>
        <Typography variant='h5'>{gameShots ? <DiffFormat>{_.sum(toPar)}</DiffFormat> : '-'}</Typography>
      </TableCell>
      <TableCell classes={classes}>
        <Typography variant='h5'>{gameShots ? <DiffFormat>{_.sum(toCh)}</DiffFormat> : '-'}</Typography>
      </TableCell>
      <TableCell classes={classes}>
        <Typography variant='h5'>{gameShots ? gamePoints : '-'}</Typography>
      </TableCell>
    </TableRow>
  )
}

const GameRow = _.compose(
  withStyles(styles)
)(GameRowBase)

const SmallTableRowBase = ({
  userHandle,
  gameId,
  clubId,
  clubName,
  guideTitle,
  gamePlayedAt,
  gameShots,
  gamePoints,
  gameHandle,
  classes
}) => (
  <TableRow
    component={Link}
    to={`/u/${userHandle}/games/${gameHandle}`}
  >
    <TableCell padding='none' colSpan={2}>
      <div className={classes.container}>
        <Avatar
          className={classes.clubLogo}
          src={getClubLogo(clubId)}
          imgProps={{
            onError: e => {
              e.target.src = 'https://my.glfr.com/static/media/glfr-logo.png'
            }
          }}
        />
        <div className={classes.courseInfo}>
          <div style={{ color: colors.black }}>
            {clubName}
          </div>
          <div>
            {guideTitle}
          </div>
          <div>
            {moment(gamePlayedAt * 1000).format('l')}
          </div>
        </div>
      </div>
    </TableCell>
    <TableCell padding='none' style={{ fontSize: 'calc(1em + 4vw)' }}>
      {gameShots}
    </TableCell>
    <TableCell padding='none' style={{ paddingRight: 6, fontSize: 'calc(1em + 4vw)' }}>
      {gamePoints}
    </TableCell>
  </TableRow>
)

const smallTableStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  clubLogo: {
    margin: '0 6px'
  },
  courseInfo: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    color: colors.lightBlue,
    margin: '0 6px',
    paddingTop: 10,
    paddingBottom: 10
  }
}

const SmallTableRow = _.compose(
  withStyles(smallTableStyles)
)(SmallTableRowBase)

const headRows = [
  { id: 'logo', numeric: false, sortable: false, disablePadding: true, width: 40, label: '' },
  { id: 'clubName', numeric: false, sortable: true, disablePadding: false, width: 350, label: 'Club' },
  { id: 'guideTitle', numeric: false, sortable: true, disablePadding: false, width: 350, label: 'Guide' },
  { id: 'gamePlayedAt', numeric: false, sortable: true, disablePadding: false, width: 'auto', label: 'Date' },
  { id: 'gameTotalPar', numeric: true, sortable: true, disablePadding: false, width: 60, label: 'Par' },
  { id: 'gameHandicap', numeric: true, sortable: true, disablePadding: false, width: 60, label: 'CH' },
  { id: 'gameShots', numeric: true, sortable: true, disablePadding: false, width: 60, label: 'Shots' },
  { id: 'toPar', numeric: true, sortable: false, disablePadding: false, width: 60, label: 'Gross' },
  { id: 'toCh', numeric: true, sortable: false, disablePadding: false, width: 60, label: 'Net' },
  { id: 'gamePoints', numeric: true, sortable: true, disablePadding: false, width: 60, label: 'Points' }
]

const smallHeadRows = [
  { id: 'clubName', numeric: false, sortable: true, disablePadding: true, width: '0', padding: '0 0 0 6px', label: 'Club' },
  { id: 'gamePlayedAt', numeric: false, sortable: true, disablePadding: true, width: 'auto', label: 'Date' },
  { id: 'gameShots', numeric: true, sortable: true, disablePadding: true, width: 'auto', label: 'Shots' },
  { id: 'gamePoints', numeric: true, sortable: true, disablePadding: true, width: 'auto', padding: '0 6px 0 0', label: 'Points' }
]

const defaultPagination = {
  limit: 100,
  offset: 0,
  orderBy: [{ name: 'gamePlayedAt', desc: true }]
}

const FullSizeTable = ({ getGames, getChangeOrderingHandler, currentOrdering, userHandle }) => (
  <Table>
    <TableHead>
      <TableRow>
        {_.map(row => (
          <TableCell
            key={row.id}
            padding={row.disablePadding ? 'none' : 'default'}
            style={{ width: row.width }}
          >
            {row.sortable
              ? (
                <TableSortLabel
                  active={currentOrdering.name === row.id}
                  direction={currentOrdering.desc ? 'desc' : 'asc'}
                  onClick={getChangeOrderingHandler(row.id)}
                >
                  {row.label}
                </TableSortLabel>
                )
              : row.label}
          </TableCell>
        ), headRows)}
      </TableRow>
    </TableHead>
    <TableBody>
      {_.map(game => <GameRow key={game.gameId} {...game} userHandle={userHandle} />, getGames)}
    </TableBody>
  </Table>
)

const SmallTable = ({ getGames, getChangeOrderingHandler, currentOrdering, userHandle }) => (
  <Table>
    <TableHead>
      <TableRow style={{ height: 28 }}>
        {_.map(row => (
          <TableCell
            key={row.id}
            padding={row.disablePadding ? 'none' : 'default'}
            style={{ width: row.width, padding: row.padding }}
          >
            {row.sortable
              ? (
                <TableSortLabel
                  active={currentOrdering.name === row.id}
                  direction={currentOrdering.desc ? 'desc' : 'asc'}
                  onClick={getChangeOrderingHandler(row.id)}
                >
                  {row.label}
                </TableSortLabel>
                )
              : row.label}
          </TableCell>
        ), smallHeadRows)}
      </TableRow>
    </TableHead>
    <TableBody>
      {_.map(game => <SmallTableRow key={game.gameId} {...game} userHandle={userHandle} />, getGames)}
    </TableBody>
  </Table>
)

const GamesList = ({ data: { getGames, networkStatus, error, refetch }, userHandle, loggedIn, classes }) => {
  const [pagination, setPagination] = useState(defaultPagination)
  const currentOrdering = _.get('orderBy.0', pagination)

  const getChangeOrderingHandler = id => () => {
    if (currentOrdering.name === id) {
      setPagination({ ...pagination, orderBy: [{ ...currentOrdering, desc: !currentOrdering.desc }] })
    } else {
      setPagination({ ...pagination, orderBy: [{ name: id, desc: false }] })
    }
  }

  useEffect(() => {
    refetch({
      pagination,
      userHandle
    })
  }, [pagination])

  if (networkStatus === 1) {
    return <Spinner title='Loading games' />
  }
  if (error) {
    console.log({ loggedIn })
    return <NoSuchUser loggedIn={loggedIn} />
  }

  return (
    <div className='outer-container'>

      <div className='container-1280'>
        <Hidden mdDown>
          <FullSizeTable
            userHandle={userHandle}
            getGames={getGames}
            getChangeOrderingHandler={getChangeOrderingHandler}
            currentOrdering={currentOrdering}
          />
        </Hidden>
        <Hidden lgUp>
          <SmallTable
            userHandle={userHandle}
            getGames={getGames}
            getChangeOrderingHandler={getChangeOrderingHandler}
            currentOrdering={currentOrdering}
          />
        </Hidden>
      </div>

    </div>
  )
}

const paperStyles = theme => ({
  root: {
    margin: 24,
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      borderRadius: 0
    }
  }
})

export default _.compose(
  withStyles(paperStyles),
  connect(
    (state, ownProps) => ({
      userHandle: _.get('match.params.userHandle', ownProps),
      loggedIn: authReducer.selectors.loggedIn(state)
    })
  ),
  graphql(gamesListQuery,
    {
      options: props => ({
        errorPolicy: 'all',
        variables: {
          pagination: { limit: 20 },
          userHandle: props.userHandle
        }
      })
    })
)(GamesList)
